import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

//Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import TableComponent from '../../../TableComponent';

// Styles
import styles from './index.module.sass';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const Alert = (props) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const { t } = useTranslation('wheel');
  const itemsTable = t('items', { returnObjects: true });
  const {
    open = alertOpen,
    setOpen = setAlertOpen,
    title = '',
    table = [],
    screenSize,
    kit,
    callback,
  } = props;

  let tableData = [];

  const handleClose = () => {
    if (callback) callback();
    setOpen(false);
  };

  for (let index = 0; index < table.length; index++) {
    if (table[index].TAUKIT === kit) {
      tableData.push(table[index]);
    }
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby='scroll-dialog-title'
      aria-describedby='scroll-dialog-description'
      fullWidth={true}
      maxWidth='lg'
      scroll='paper'>
      <DialogTitle id='scroll-dialog-title' className={styles.title}>
        {title} - TE{kit}
      </DialogTitle>
      <DialogContent id='scroll-dialog-description' className={styles.text} tabIndex={-1}>
        <TableComponent screenSize={screenSize} tableData={tableData} tableItems={itemsTable} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} className={styles.button} variant='contained'>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Alert;
